// =============================================================================
// Xử lý lỗi tải chunk sau khi DEPLOY (stale chunk).
//
// SPA build ra file JS có hash trong tên (vd materials-B2vo9tuD.js). Mỗi lần
// deploy, hash đổi → file cũ bị xoá trên server. Trình duyệt đang mở bản CŨ khi
// điều hướng sẽ cố tải chunk cũ → 404 → "Failed to fetch dynamically imported
// module". Không phải lỗi thật — chỉ cần TẢI LẠI trang để lấy index.html + chunk
// mới. Guard chống lặp vô hạn (nếu tải lại vẫn lỗi = sự cố thật).
// =============================================================================

// Nhận diện lỗi tải chunk động (khác nhau theo trình duyệt). Bao cả lỗi preload
// CSS của Vite và ChunkLoadError.
export function isChunkLoadError(err: unknown): boolean {
  const msg = (
    err instanceof Error ? `${err.name} ${err.message}` : String(err ?? '')
  ).toLowerCase()
  return (
    msg.includes('failed to fetch dynamically imported module') || // Chrome/Edge
    msg.includes('error loading dynamically imported module') || // Firefox
    msg.includes('importing a module script failed') || // Safari
    msg.includes('unable to preload css') || // Vite CSS preload
    msg.includes('chunkloaderror')
  )
}

const RELOAD_TS_KEY = 'app:last-chunk-reload'
const RELOAD_GUARD_MS = 10_000

// Đọc/ghi mốc lần tải lại gần nhất (sessionStorage — reset theo tab). Bọc try/catch
// phòng trình duyệt chặn storage (chế độ riêng tư) → coi như chưa từng reload.
function lastReloadAt(): number {
  try {
    return Number(sessionStorage.getItem(RELOAD_TS_KEY) || '0')
  } catch {
    return 0
  }
}
function markReloaded(now: number): void {
  try {
    sessionStorage.setItem(RELOAD_TS_KEY, String(now))
  } catch {
    // Bỏ qua — không ghi được thì lần sau vẫn cho reload (chấp nhận rủi ro loop hiếm).
  }
}

// Chỉ cho phép TỰ tải lại nếu chưa reload trong RELOAD_GUARD_MS gần đây → chống
// vòng lặp reload khi lỗi KHÔNG tự khỏi (server hỏng thật). Trả true nếu vừa kích
// hoạt reload; false nếu vừa reload xong mà vẫn lỗi (caller nên hiện lỗi thủ công).
export function reloadForNewVersion(now: number = Date.now()): boolean {
  if (now - lastReloadAt() <= RELOAD_GUARD_MS) return false
  markReloaded(now)
  window.location.reload()
  return true
}

// Đã tự tải lại gần đây chưa? (để boundary biết nên chờ reload hay hiện thẻ lỗi).
export function reloadedRecently(now: number = Date.now()): boolean {
  return now - lastReloadAt() <= RELOAD_GUARD_MS
}
